import { defineStore } from "pinia";
import { InteractionStatus2Enum } from "@/utils/constants.js";
import { useUserStore } from "./user";
import api from "@/api";

function defaultStatusCountMap() {
  const statusCounts = {};
  for (const key in InteractionStatus2Enum) {
    const status = InteractionStatus2Enum[key];
    statusCounts[status] = 0;
  }
  return statusCounts;
}

function defaultInteractionCounts() {
  return {
    all_tickets: {
      page_enum: "ALL_TICKETS",
      total_count: 0,
      active_count: 0,
      status_count_map: defaultStatusCountMap(),
    },
    my_tickets: {
      page_enum: "MY_TICKETS",
      total_count: 0,
      active_count: 0,
      status_count_map: defaultStatusCountMap(),
    },
    my_teams: {
      page_enum: "MY_TEAMS",
      total_count: 0,
      active_count: 0,
      status_count_map: defaultStatusCountMap(),
    },
    my_departments: {
      page_enum: "MY_DEPARTMENTS",
      total_count: 0,
      active_count: 0,
      status_count_map: defaultStatusCountMap(),
    },
    all_soft_alerts: {
      page_enum: "ALL_SOFT_ALERTS",
      total_count: 0,
      active_count: 0,
      status_count_map: defaultStatusCountMap(),
    },
    my_soft_alerts: {
      page_enum: "MY_SOFT_ALERTS",
      total_count: 0,
      active_count: 0,
      status_count_map: defaultStatusCountMap(),
    },
    all_interactions: {
      page_enum: "ALL_INTERACTIONS",
      total_count: 0,
      active_count: 0,
      status_count_map: defaultStatusCountMap(),
    },
    va_interactions: {
      page_enum: "VA_INTERACTIONS",
      total_count: 0,
      active_count: 0,
      status_count_map: defaultStatusCountMap(),
    },
    user_tickets: {
      page_enum: "USER_TICKETS",
      total_count: 0,
      active_count: 0,
      status_count_map: defaultStatusCountMap(),
    },
  };
}

function defaultTrainingCounts() {
  return {
    my_trainings: 0,
    for_my_review: 0,
    live: 0,
  };
}

export const useCountsStore = defineStore("counts", {
  state: () => ({
    interactionCounts: defaultInteractionCounts(),
    trainingCounts: defaultTrainingCounts(),
  }),
  actions: {
    async fetchInteractionCounts() {
      try {
        const userStore = useUserStore()
        const activeOrganization = userStore.activeOrganization ?? null
        const result = await api.counts.fetchInteractionPageCounts(activeOrganization);
        this.interactionCounts = Object.assign(result.data);
      } catch (error) {
        console.error("Error fetching interaction counts:", error);
      }
    },
    async fetchTrainingCounts() {
      try {
        const userStore = useUserStore()
        const activeOrganization = userStore.activeOrganization ?? null
        const result = await api.counts.fetchTrainingPageCounts(activeOrganization);
        this.trainingCounts = result.data;
      } catch (error) {
        console.error("Error fetching training counts:", error);
      }
    },
  },
});
